import {
	BrowserRouter,
	Routes as Switch,
	Route,
  Navigate
  } from 'react-router-dom';
import Header from './../Components/Dashboards/Layouts/Header';
import Footer from './../Components/Dashboards/Layouts/Footer';
import Home from './../Components/Dashboards/Pages/Homes/Index.js'
import Fanpage from './../Components/Dashboards/Pages/Fanpages/Index.js'
import Post from './../Components/Dashboards/Pages/Fanpages/Posts/Index.js'
import Webhook from './../Components/Dashboards/Pages/Fanpages/Webhook/Index.js'
import ChatRealTime from './../Components/Dashboards/Pages/Fanpages/ChatRealTime/Index.js'
import Message from './../Components/Dashboards/Pages/Fanpages/Messages/Index.js'
import GroupFanpage from '../Components/Dashboards/Pages/Fanpages/Groups/Index.js'
import './../Css/dashboard.scss'
import List from './../Components/Dashboards/Pages/Products/Index';
import Setting from './../Components/Dashboards/Pages/Settings/Index';
import ChangeShopActive from './../Components/Dashboards/Pages/Shop/ChangeShopActive';
import Order from './../Components/Dashboards/Pages/Orders/Index';
import OrderDetail from './../Components/Dashboards/Pages/Orders/Components/OrderDetail';
import Price from '../Components/Dashboards/Pages/Prices/Index';
import Customer from '../Components/Dashboards/Pages/Customers/Index';
import { useEffect } from 'react';
import { useCookies } from "react-cookie";
import Revenue from './../Components/Dashboards/Pages/Revenues/Index';
import Expense from './../Components/Dashboards/Pages/Expenses/Index';
import Bank from './../Components/Dashboards/Pages/Banks/Index';
import Transaction from './../Components/Dashboards/Pages/Transactions/Index';
import CheckPhoneNumber from './../Components/Dashboards/Pages/CheckPhoneNumbers/Index';
import CalculatorFee from './../Components/Dashboards/Pages/CalculatorFees/Index';
import LiveChat from './../Components/Dashboards/Pages/Fanpages/Messages/Index';
import {
  useNavigate
} from "react-router-dom";
import ChatBot from '../Components/Dashboards/Pages/ChatBots/Index';
import ReactSelectFast from '../Components/Dashboards/ReactSelectFast.js';
import Pricing from '../Components/Dashboards/Pages/Pricing/Index.js';
import { BusinesseManagement } from '../Components/Dashboards/BusinesseManagement/BusinesseManagement.js';
import Process from '../Components/Dashboards/Pages/Fanpages/Process/Index.js';
import AssistantTraining from '../Components/Dashboards/Pages/AssistantTraining/Index.js';
import UsageHistory from '../Components/Dashboards/Pages/UsageHistory/Index.js';
import AssistantChat from '../Components/Dashboards/Pages/AssistantChat/Index.js';
import Ai from '../Components/Dashboards/Pages/Ai/Ai.js';
import FanpageLayout from '../Components/Dashboards/Layouts/FanpageLayout.js';
import SplitGroupFanpage from '../Components/Dashboards/Pages/Fanpages/Groups/components/SplitGroupFanpage.js';
import SettingLayout from '../Components/Dashboards/Layouts/SettingLayout.js';
import CustomerLayout from '../Components/Dashboards/Layouts/CustomerLayout.js';

function DashboardRoute() {
  const [cookies, setCookie, removeCookie] = useCookies(['is_login']);
  let navigate = useNavigate();
  
  useEffect(() => {
    if (cookies.is_login == undefined) {
      return navigate('/');
    }
  }, [])

	return (
        <div>
            <Header />
            <Switch>
                {/* <Route path='/process' element={<Process/>}/> */}
                <Route path='/price' element={<Price/>}/>
                <Route path='/businesse-management' element={<BusinesseManagement/>}/>
                <Route path='pricing' element={<Pricing/>} />
                <Route path='fanpage' element={<Fanpage />} />
                {/* <Route path='fanpage/group' element={<GroupFanpage/>}/> */}
                <Route path='revenue' element={<Revenue/>}></Route>
                <Route path='expense' element={<Expense/>}></Route>
                <Route path='chat' element={<ChatRealTime/>} />
                <Route path='/product' element={<List/>}/>
                {/* <Route path='setting' element={<Setting/>} /> */}
                <Route path='setting' element={<SettingLayout/>} >
                  <Route index element={<Navigate to={"info"} />} />
                  <Route path='info' element={<Setting tab_value={"info"} />} />
                  <Route path='employee' element={<Setting tab_value={"employee"} />} />
                  <Route path='mess-sample' element={<Setting tab_value={"mess_sample"} />} />
                  <Route path='coupon-message' element={<Setting tab_value={"coupon_message"} />} />
                  <Route path='tag' element={<Setting tab_value={"tag"} />} />
                  <Route path='transport' element={<Setting tab_value={"transport"} />} />
                  <Route path='warehouse' element={<Setting tab_value={"warehouse"} />} />
                  <Route path='keyword' element={<Setting tab_value={"keyword"} />} />
                </Route>
                <Route path='order' element={<Order/>} />
                <Route path='fee' element={<CalculatorFee/>} />
                <Route path="live-chat" element={<LiveChat/>}/>
                <Route path='check-phone-number' element={<CheckPhoneNumber/>}/>
                <Route path=':fanpage_id/chatbot' element={<ChatBot/>}/>
                {/* <Route path="bank" element={<Bank/>}/> */}
                {/* <Route path=":fanpage_id/customer" element={<Customer/>}/> */}
                <Route path=":fanpage_id/" element={<CustomerLayout/>}>
                  <Route index element={<Navigate to={"customer"} />} />
                  <Route path='customer' element={<Customer tab_value="customer" />}/>
                  <Route path='scan-old-customer' element={<Customer tab_value="scan-old-customer" />} />
                  <Route path='send-customer-care-message' element={
                    <Customer tab_value="send-customer-care-message" />
                  }/>
                  <Route path='campaign' element={<Customer tab_value="campaign" />} />
                </Route>
                <Route path=':id/order' element={<OrderDetail/>}/>
                {/* <Route path='fanpage/:id/bai-viet' element={<Post/>} /> */}
                {/* <Route path='transaction' element={<Transaction/>}/> */}
                <Route path='shop/:id' element={<ChangeShopActive/>}/>
                {/* <Route path='fanpage/:fanpage_id/setting' element={<Setting/>}/> */}
                <Route path='fanpage/:id/webhook-setting' element={<Webhook/>}/>
                <Route path='fanpage/:fanpage_id/tin-nhan' element={<Message/>}/>
                <Route path='/' element={<Home />} />
                <Route path='/ai/training/:ai_id' element={<AssistantTraining />} />
                <Route path='usage-history' element={<UsageHistory />} />
                <Route path='/ai/chat/:ai_id' element={<AssistantChat />} />
                <Route path='ai' element={<Ai/>} />
                <Route path='/*' element={<FanpageLayout />}> 
                  {/* <Route path='fanpage/:id/bai-viet' element={<Post/>} /> */}
                  <Route path='split-group' element={<SplitGroupFanpage/>} />
                  <Route path='group' element={<GroupFanpage/>}/>
                  <Route path='process' element={<Process/>}/>
                  <Route path='add-post' element={<Post publish_type={"post"}/>} />
                  <Route path='add-story' element={<Post publish_type={"story"}/>} />
                  <Route path='add-reels' element={<Post publish_type={"reels"}/>} />
                  {/* <Route path='process' element={<Process/>}/> */}
                </Route>
            </Switch>
        </div>
	)
}

export default DashboardRoute;